import React, { useRef } from "react";
import banner from "../../asset/about us banner.png";
import bannerSm from "../../asset/about us banner sm.png";
import AboutRDA from "../../component/About RDA/AboutRDA";
import rawalpindiImage from "../../asset/about-image.png";
import { NavLink } from "react-router-dom";
import AboutAuthorityImage from "../../asset/About Authority.png";
import AboutAuthoritySmImage from "../../asset/About Authority sm.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import { Autoplay, Pagination, Navigation, FreeMode } from "swiper/modules";
import SwiperCore from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ManagementCard from "./ManagementCard";
import { useInView } from "react-intersection-observer";
import { useGetAllPublicGeneralDirectorQuery } from "../../Redux/getApi";
import { NotFound } from "../../component/About Management/AboutManagement";

SwiperCore.use([Navigation]);

const AboutUs = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { data, isLoading, isFetching } = useGetAllPublicGeneralDirectorQuery();
  const profiles = data?.profiles;

  const sliderData = [
    {
      name: "Governing Body",
      list: [
        "Chairman.",
        "03 members of Provincial Assembly",
        "Chairman Planning & Development Board or his representative.",
        "Secretary of the Govt. of Punjab, Finance Department or his representative.",
      ],
    },
    {
      name: "Directorates",
      list: [
        "To take measures to ensure optimum utilization of resources",
        "To ensure economical & effective utilization of land",
        "To prepare & execute new schemes",
        "To approve budget & make regulations",
      ],
    },
    {
      name: "Powers & Functions of Authority",
      list: [
        "To take measures to ensure optimum utilization of resources",
        "To ensure economical & effective utilization of land",
        "To prepare & execute new schemes",
        "To approve budget & make regulations",
      ],
    },
  ];

  const { ref: refOne, inView: inViewOne } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: refTwo, inView: inViewTwo } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className=" flex flex-col md:gap-10 gap-6 bg-white md:bg-[#F6F6F6]">
      <div
        className="flex justify-center overflow-hidden   xl:py-6 lg:py-4 py-3 xl:px-[5%] lg:px-[3%] 
        px-[3%]  relative"
      >
        <div className="relative w-full lg:rounded-2xl md:rounded-xl rounded-lg overflow-hidden ">
          <img
            src={banner}
            alt=""
            className="w-full object-cover md:flex hidden"
          />
          <img
            className="w-full object-cover  flex md:hidden"
            src={bannerSm}
            alt=""
          />

          <div className="absolute inset-0 bg-gradient-to-t from-[#00000083] to-transparent"></div>
        </div>

        <div
          className=" absolute w-full h-full flex flex-col md:items-center items-start justify-center md:gap-3 gap-2 xl:py-6 lg:py-4 py-3 xl:px-[5%] lg:px-[3%] 
        px-[3%]"
        >
          <span className=" bg-white text-[#00643B] uppercase xl:text-xl lg:text-lg md:text-base text-sm md:ml-0 ml-3 leading-none font-semibold xl:py-2 py-[6px] px-4 rounded-full ">
            About US
          </span>
          <h1 className=" md:ml-0 ml-3 2xl:text-[4.75rem] xl:text-[4rem] lg:text-[3.2rem] md:text-[2.5rem] text-[1.75rem] text-white font-bold md:text-center text-left uppercase leading-[1]">
            The home of new property <br /> developments
          </h1>
          <p className=" text-[#D4D4D4] 2xl:text-xl xl:text-lg lg:text-base md:text-sm above-320:text-sm text-xs md:text-center text-left xl:w-[70%] lg:w-[80%] md:w-[95%] w-[98%] pl-3 md:pl-0 md:mx-auto leading-[1.2]">
            Rawalpindi Development Authority (RDA) was established in May 1989
            under the Punjab Development of Cities Act, 1976 as an autonomous
            governing body of the Government of Punjab, replacing the Rawalpindi
            Improvement Trust (RIT). The Rawalpindi Development Authority
            formally began functioning in March 1992.
          </p>
        </div>

        {/* <div className=" absolute md:w-[80%] w-[90%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white flex flex-col justify-center items-center md:gap-3 gap-1">
          <span className=" uppercase bg-white md:py-1.5 py-1 px-3 text-[#00643b] font-semibold xl:text-[1rem] lg:text-[.9rem] md:text-[.8rem] text-[10px] rounded-full">
            About us
          </span>
          <h1 className="xl:text-[3.5rem] lg:text-[2.5rem] md:text-[1.8rem] text-[.85rem] leading-tight font-bold uppercase text-center">
            The home of new property developments
          </h1>
          <p className="text-center xl:text-[1.2rem] lg:text-[1rem] md:text-[.85rem] text-[10px]">
            Lorem ipsum is a dummy or placeholder text commonly used in graphic
            design, publishing, and web development.Lorem ipsum is a dummy or
            placeholder text commonly used in graphic design, publishing, and
            web development.
          </p>
        </div> */}
      </div>
      {/* About Rawalpindi Development Authority */}
      <div className="xl:px-[5%] lg:px-[3%] md:px-[2%] px-[4%] ">
        <AboutRDA />
      </div>
      {/* About RAWALPINDI */}
      <div className="w-full sm:flex-none flex flex-col gap-5 relative lg:pb-40 xl:px-[5%] lg:px-[3%] px-[2%]  ">
        <img
          ref={refOne}
          src={rawalpindiImage}
          className={`xl:w-[80%] lg:w-[90%]  md:rounded-[2rem] rounded-lg sm:flex hidden ${
            inViewOne ? "animate-slideRight" : "opacity-0"
          }`}
          alt=""
        />
        <div
          ref={refTwo}
          className={`bg-[#00643b] xl:p-8 lg:p-5 md:p-6 p-4 rounded-2xl lg:w-[50%] md:w-[65%] sm:w-[85%] w-[90%] sm:mx-0 mx-auto text-white flex flex-col xl:gap-5 lg:gap-3 gap-4 sm:absolute xl:top-[45%] xl:left-[45%] lg:top-[55%] lg:left-[45%] sm:top-1/2 sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:-translate-y-1/2 
                  lg:translate-x-0 lg:translate-y-0 ${
                    inViewTwo ? "animate-slideLeft" : "opacity-0"
                  } `}
        >
          <h1 className=" uppercase font-bold xl:text-[2rem] lg:text-[1.5rem] text-[1.8rem]">
            About Rawalpindi
          </h1>
          <p>
            Rawalpindi راولپݨڈى,  commonly known as Pindi پݨڈى,, is a city and
            capital of Rawalpindi Division located in the Punjab province of
            Pakistan. Rawalpindi is the fourth-largest city proper in Pakistan,
            while the larger Islamabad-Rawalpindi metropolitan area is also the
            country’s fourth-largest metropolitan area. Rawalpindi is adjacent
            to Pakistan’s capital of Islamabad, and the two are jointly known as
            the “twin cities” on account of strong social and economic links
            between the cities.
          </p>
          <NavLink
            to={"/rawalpindi"}
            className="w-max bg-white py-1.5 px-5 text-[#00643b] font-semibold text-[1rem] rounded-full"
          >
            Learn more
          </NavLink>
        </div>
      </div>
      {/* About Authority */}
      <div className="md:bg-[#00643b] bg-transparent xl:px-[5%] lg:px-[3%] md:px-[2%] px-[4%] lg:py-12 py-8 space-y-3 md:text-white text-black mb-10">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          loop={true}
          modules={[Autoplay, Pagination, Navigation, FreeMode]}
        >
          {sliderData.map((slider, i) => (
            <SwiperSlide>
              <div
                key={i}
                className=" px-1 flex md:flex-row bg-transparent flex-col-reverse items-start lg:gap-8 gap-6"
              >
                <div className="flex-1 flex flex-col gap-5">
                  <h1 className="uppercase font-bold lg:text-[2rem] text-[1.8rem]">
                    About Authority
                  </h1>
                  <p className="md:text-[#e4e4e4] text-[#00000085] text-[1.2rem]">
                    The Governing Body consists of Chairman, DG RDA,
                    Commissioner, DC...
                  </p>
                  <NavLink
                    to={"/authority"}
                    className="w-max md:bg-white bg-[#00643b] py-2 px-5 md:text-[#00643b] text-white font-semibold text-[1rem] rounded-xl"
                  >
                    Learn more
                  </NavLink>
                  <div className="flex flex-col gap-4">
                    <h1 className="lg:text-[1.5rem] text-[1.3rem] font-semibold">
                      {slider?.name}
                    </h1>
                    <ul className="list-disc pl-8 text-[1rem] uppercase md:text-[#e4e4e4] text-[#00000085] font-medium">
                      {slider.list.map((li, i) => (
                        <li key={i}>{li}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="flex-1 flex justify-end">
                  <img
                    src={AboutAuthorityImage}
                    className="md:w-[80%] hidden md:flex "
                    alt="Authority"
                  />
                  <img
                    src={AboutAuthoritySmImage}
                    className="w-full flex md:hidden rounded-lg "
                    alt="Authority"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation Buttons */}
        <div className="hidden md:flex gap-4 items-center  text-[#00643b]">
          <button ref={prevRef} className="p-4 bg-white rounded-full">
            <IoIosArrowBack className="size-6" />
          </button>

          <button ref={nextRef} className="p-4 bg-white rounded-full">
            <IoIosArrowForward className="size-6" />
          </button>
        </div>
      </div>
      {/* About Management */}
      <div className="flex flex-col items-center  justify-center gap-8 mb-16">
        <div className=" flex md:flex-row flex-col md:gap-0 gap-3 md:items-end items-center md:justify-between w-full xl:px-[5%] lg:px-[3%] md:px-[2%] px-[4%]">
          <div className="  w-full">
            <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-center text-[2rem] font-bold  ">
              About Management
            </h1>
            <p className=" text-center  mx-auto text-[#5A5A5A] md:text-[1.2rem] text-[1rem]">
              Discover the organizational structure of Rawalpindi Development
              Authority
            </p>
          </div>
        </div>
        {profiles?.length === 0 ? (
          <NotFound />
        ) : (
          <>
            <div className="flex items-stretch justify-center flex-wrap gap-6 lg:w-[90%] w-[95%] max-w-5xl mx-auto ">
              {isFetching || isLoading ? (
                <TeamCardSkeleton items={3} />
              ) : (
                profiles?.map((profile, i) => (
                  <ManagementCard key={i} index={i} profile={profile} />
                ))
              )}
            </div>
            <NavLink
              to={"/management"}
              className="w-max text-white py-2 px-5  bg-[#00643b] font-semibold text-[1rem] rounded-xl"
            >
              Learn more
            </NavLink>
          </>
        )}
      </div>
    </div>
  );
};

export const TeamCardSkeleton = ({ items }) => {
  return (
    <>
      {[...Array(items)].map((_, i) => (
        <div
          key={i}
          className="w-full max-w-xs bg-[#DEE9E4] rounded-2xl p-4 flex flex-col items-center animate-pulse"
        >
          {/* Profile image placeholder */}
          <div className="w-full aspect-[1/1.2] bg-gray-200 rounded-xl"></div>

          {/* Mail button */}
          <div className="relative w-full mt-6 flex justify-center">
            <div className="absolute  h-6 w-12 rounded-2xl top-[-24px] left-1/2 transform -translate-x-1/2 bg-gray-300"></div>
          </div>

          {/* Text placeholders */}
          <div className="mt-8 text-center space-y-2 w-full">
            <div className="h-3 w-3/4 bg-gray-200 rounded mx-auto"></div>
            <div className="h-3 w-1/2 bg-gray-200 rounded mx-auto"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default AboutUs;
